/* Custom search quick-view drawer — functional variant selection + add to cart.
   Loaded only when settings.custom_search_card_v2_enable is on. Scoped to .custom_search_qv.
   Reuses the theme's proven cart pattern (POST /cart/add.js + re-render hdt-cart-drawer). */
(function () {
  'use strict';

  // Open the mini-cart the SAME way a user click would: trigger the theme's own
  // opener ([aria-controls="CartDrawer"]) instead of calling showModal() directly,
  // so the theme's controller keeps its state/scroll-lock in sync (no breakage).
  function openCartDrawer() {
    var opener = document.querySelector('a[aria-controls="CartDrawer"]');
    if (opener) { opener.click(); return true; }
    return false;
  }

  function hideSizeAlert(drawer) {
    var a = drawer.querySelector('[data-qv-size-alert]');
    if (a) { a.classList.remove('is--show'); if (a.__t) clearTimeout(a.__t); }
  }
  function showSizeAlert(drawer) {
    var a = drawer.querySelector('[data-qv-size-alert]');
    if (!a) return;
    a.classList.add('is--show');
    if (a.__t) clearTimeout(a.__t);
    a.__t = setTimeout(function () { a.classList.remove('is--show'); }, 2500);
  }

  function updateCartCount(count) {
    document.querySelectorAll('hdt-cart-count').forEach(function (el) { el.textContent = count; });
  }

  function refreshCart() {
    var cartDrawerEl = document.querySelector('hdt-cart-drawer[section-id]');
    var sectionId = cartDrawerEl && cartDrawerEl.getAttribute('section-id');
    var cartComponent = document.querySelector('cart-items-component');

    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});

    if (!sectionId || !cartComponent) return;

    fetch('/?sections=' + sectionId).then(function (r) { return r.json(); }).then(function (data) {
      var html = data[sectionId];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newComponent = parsed.querySelector('cart-items-component');
      if (newComponent) cartComponent.innerHTML = newComponent.innerHTML;
      var newBottom = parsed.querySelector('[ref="cart-bottom"]');
      var currentBottom = cartComponent.querySelector('[ref="cart-bottom"]');
      if (newBottom && currentBottom) currentBottom.innerHTML = newBottom.innerHTML;
      var newCount = parsed.querySelector('hdt-cart-drawer[data-count]');
      if (newCount && cartDrawerEl) cartDrawerEl.setAttribute('data-count', newCount.getAttribute('data-count'));
    }).catch(function () {});
  }

  function closeQvDrawer(drawer) {
    var closeBtn = drawer && drawer.querySelector('.custom_search_qv__close');
    if (closeBtn) closeBtn.click();
  }

  // "Loading" feedback: the button just dims (opaque) while the request is in flight.
  function startLoading(btn) {
    btn.disabled = true;
    btn.classList.add('is--loading');
    btn.setAttribute('aria-busy', 'true');
  }
  function stopLoading(btn) {
    btn.classList.remove('is--loading');
    btn.removeAttribute('aria-busy');
  }

  function addToCart(variantId, btn, drawer) {
    var original = btn.getAttribute('data-label') || btn.textContent.trim();
    btn.setAttribute('data-label', original);
    startLoading(btn);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) { if (!res.ok) throw new Error('cart ' + res.status); return res.json(); })
      .then(function () {
        stopLoading(btn);
        btn.textContent = 'ADDED';
        refreshCart();
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
          closeQvDrawer(drawer);
          // open the mini-cart AFTER ours closes; the "ADDED" state is the fallback
          // confirmation if there is no cart opener on the page.
          setTimeout(openCartDrawer, 90);
        }, 800);
      })
      .catch(function (err) {
        console.error('Quick-view add error:', err);
        stopLoading(btn);
        btn.textContent = 'ERROR';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
  }

  function getVariants(drawer) {
    var script = drawer.querySelector('.custom_search_qv__variants');
    if (!script) return null;
    try { return (JSON.parse(script.textContent) || {}).variants || null; } catch (e) { return null; }
  }

  function resolve(drawer) {
    var variants = getVariants(drawer);
    var atc = drawer.querySelector('[data-qv-atc]');
    if (!variants || !atc) return;

    var colorRequired = variants.some(function (v) { return v.c !== null; });
    var sizeRequired = variants.some(function (v) { return v.s !== null; });

    var selColor = drawer.querySelector('.custom_search-swatch.is--selected');
    var selSize = drawer.querySelector('.custom_search_qv__size.is--selected');
    var color = selColor ? selColor.getAttribute('data-value') : null;
    var size = selSize ? selSize.getAttribute('data-value') : null;

    var ready = true;
    if (colorRequired && !color) ready = false;
    if (sizeRequired && !size) ready = false;

    var match = null;
    if (ready) {
      match = variants.find(function (v) {
        return (!colorRequired || v.c === color) && (!sizeRequired || v.s === size);
      });
    }

    var skuEl = drawer.querySelector('[data-qv-sku]');
    if (match && match.available) {
      atc.setAttribute('data-variant-id', String(match.id));
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      hideSizeAlert(drawer);
    } else {
      atc.removeAttribute('data-variant-id');
    }
  }

  function initDrawer(drawer) {
    if (drawer.__qvInit) return;
    drawer.__qvInit = true;
    resolve(drawer);
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.custom_search_qv .custom_search-swatch[data-value]');
    if (sw) {
      var d1 = sw.closest('.custom_search_qv');
      d1.querySelectorAll('.custom_search-swatch').forEach(function (s) { s.classList.remove('is--selected'); });
      sw.classList.add('is--selected');
      var nameEl = d1.querySelector('[data-qv-color-name]');
      if (nameEl) nameEl.textContent = (sw.getAttribute('data-value') || '').toUpperCase();
      resolve(d1);
      return;
    }

    var sz = e.target.closest('.custom_search_qv .custom_search_qv__size');
    if (sz) {
      if (sz.classList.contains('unavailable')) return;
      var d2 = sz.closest('.custom_search_qv');
      d2.querySelectorAll('.custom_search_qv__size').forEach(function (s) { s.classList.remove('is--selected'); });
      sz.classList.add('is--selected');
      resolve(d2);
      return;
    }

    var atc = e.target.closest('.custom_search_qv [data-qv-atc]');
    if (atc) {
      if (atc.disabled) return; // ignore while a request is in flight
      e.preventDefault();
      var d3 = atc.closest('.custom_search_qv');
      var vid = atc.getAttribute('data-variant-id');
      if (!vid) { showSizeAlert(d3); return; } // no size chosen -> subtle hint, no cart add
      addToCart(vid, atc, d3);
    }
  });

  function initAll() {
    document.querySelectorAll('.custom_search_qv').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var mo = new MutationObserver(function () { initAll(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
